import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=2c0606fe&scoped=true"
import script from "./NormalButton.vue?vue&type=script&lang=js"
export * from "./NormalButton.vue?vue&type=script&lang=js"
import style0 from "./NormalButton.vue?vue&type=style&index=0&id=2c0606fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0606fe",
  null
  
)

export default component.exports